module.exports = __webpack_public_path__ + "img/verticalblackrockwaterfalls_thumb.018de2e5.jpg";